import { dictionary } from 'common/language/dictionary';
import { I18nNamespace } from 'common/language/namespace';

export const CancelInputI18n = {
  configuration: { namespace: I18nNamespace.CANCEL_INPUT, labelKey: 'label' },
  translations: {
    label: dictionary.cancel,
  },
};
